import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { Cartao } from '../models/cartao';
import { CartaoCadastro } from '../models/cartao-cadastro';
import { CartaoPeriodoPadrao } from '../models/cartao-periodo-padrao';
import { CartaoCadastroLote } from '../models/cartao-cadastro-lote';
import { environment } from 'src/environments/environment';
import { CardPaged } from '../models/response/card-paged';
import { Card } from '../models/card';
import { CreateCard } from '../models/create-card';
import { AddBatchCards, AddCards } from '../models/add-cards';

@Injectable({
    providedIn: 'root'
})
export class CartaoService {

    API: string = environment.API + 'Portal/cartoes';
    APICartaoPeriodosPadroes: string = environment.API + 'Portal/cartaoperiodospadroes';

    private URL = environment.GATEWAY;

    constructor(private http: HttpClient) {
    }

    getValid(colaboradorId: number, cedenteContratoId: number, cedenteGuid: string): Observable<ResponseBase<Cartao>> {
        return this.http.get<ResponseBase<Cartao>>(`${this.API}/valid/colaboradores/${colaboradorId}/contratos/${cedenteContratoId}/cedentes/${cedenteGuid}`);
    }

    add(colaboradorId: number, cedenteContratoId: number, cedenteGuid: string, cartaoCadastro: CartaoCadastro): Observable<ResponseBase<Cartao>> {
        return this.http.post<ResponseBase<Cartao>>(`${this.API}/colaboradores/${colaboradorId}/contratos/${cedenteContratoId}/cedentes/${cedenteGuid}`, cartaoCadastro);
    }

    addLote(cedenteGuid: string, cartaoCadastroLote: CartaoCadastroLote): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.API}/cadastro/lote/cedente/${cedenteGuid}`, cartaoCadastroLote);
    }

    update(cartaoId: number, cedenteContratoId: number, cedenteGuid: string, cartaoCadastro: CartaoCadastro): Observable<ResponseBase<Cartao>> {
        return this.http.put<ResponseBase<Cartao>>(`${this.API}/${cartaoId}/contratos/${cedenteContratoId}/cedentes/${cedenteGuid}`, cartaoCadastro);
    }

    getAllCartaoPeriodoPadrao(): Observable<ResponseBase<CartaoPeriodoPadrao[]>> {
        return this.http.get<ResponseBase<CartaoPeriodoPadrao[]>>(this.APICartaoPeriodosPadroes);
    }

    getAllCardPaged(assignorGuid: string, page: number, limit: number): Observable<ResponseBase<CardPaged>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');

        return this.http.get<ResponseBase<CardPaged>>(
            `${this.URL}card/${assignorGuid}/page/${page}/limit/${limit}`, { headers }
        );
    }

    create(createCard: CreateCard): Observable<ResponseBase<Card>> {
        return this.http.post<ResponseBase<Card>>(`${this.URL}card/create`, createCard);
    }

    newUpdate(createCard: CreateCard): Observable<ResponseBase<Card>> {
        return this.http.put<ResponseBase<Card>>(`${this.URL}card/update`, createCard);
    }

    getValidCardBatch(collaboratorId: number, assignorGuid: string, assignorContractsId: number[]): Observable<ResponseBase<Card[]>> {
        return this.http.post<ResponseBase<Card[]>>(`${this.URL}card/collaborator/${collaboratorId}/assignor/${assignorGuid}/valid`, assignorContractsId);
    }

    newAdd(addCards: AddCards, isFlex: boolean): Observable<ResponseBase<any>> {
        let params = new HttpParams();
        params = params.append('isFlex', isFlex.toString());
        return this.http.post<ResponseBase<any>>(`${this.URL}card/add`, addCards, {params});
    }

    newAddBatch(AddBatchCards: AddBatchCards, isFlex: boolean): Observable<ResponseBase<any>> {
        let params = new HttpParams();
        params = params.append('isFlex', isFlex.toString());
        return this.http.post<ResponseBase<any>>(`${this.URL}card/add/batch`, AddBatchCards, {params});
    }

    statusBatch(batchId: number, assignorGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<any>>(`${this.URL}card/batch/status/${batchId}/assignor/${assignorGuid}`, { headers });
    }
}
